<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ow9Fkh/tc-custom/9780547527116.jpg?1736425677204" alt="This image is the cover for the book Friendship"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Friendship
      </h1>
      <p class="bookDescription body article font2">
        <b>The amusing and erudite anatomy of modern friendship, from the <i>New York Times</i>–bestselling author of <i>Snobbery</i>.</b><br/><br/> Is it possible to have too many friends? Is your spouse supposed to be your best friend? How far should you go to help a friend in need? And how do you end a friendship that has run its course?<br/>  <br/> In a “smart, delightfully literate, and sophisticated” anatomy of friendship in all its contemporary guises, Joseph Epstein uncovers the rich and surprising truths about our favored companions (<i>Los Angeles Times</i>). <i>Friendship</i> illuminates those complex, wonderful relationships without which we’d all be lost.<br/>  <br/> “Reading [Epstein] is like spending an evening being flatteringly entertained by the most interesting guy at the party.” —<i>The Seattle Times</i><br/>  <br/> “A brilliant and outspoken commentator . . . Epstein’s graceful style and irrepressible wit provide unalloyed pleasure.” —<i>Chicago Tribune</i><br/>  <br/> “Brisk and delightful.” —<i>The Wall Street Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Epstein
      </h2>
      
      <p class="authorDescription body article">Joseph Epstein is the author of the bestselling <I>Snobbery</I> and of <I>Friendship</I>, among others, and was formerly editor of the <I>American Scholar</I>. His work has appeared in the<I> New Yorker</I>, <I>Harper&rsquo;s Magazine</I>, the <I>Atlantic Monthly</I>, and other magazines. Epstein lives in Evanston, Illinois.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c803d76